// dependencies
import React from "react";
import { useIntl } from "react-intl";

// components
import Button from "@cloudspire/legacy-resources/src/components/Button2";
import { IconMapO } from "@cloudspire/legacy-svg-icon-library";
import Text from "../Text";

type PropsType = {
  opened: boolean;
  onPress;
};

const ButtonMap: React.FunctionComponent<PropsType> = (props) => {
  const { opened, onPress } = props;

  const intl = useIntl();

  const label = intl.formatMessage(
    {
      defaultMessage:
        "{opened, select, yes {Masquer la carte} other {Afficher la carte}}",
    },
    { opened: opened ? "yes" : "no" }
  );

  return (
    <Button appearance="primary" label={label} onPress={onPress}>
      <Text style={{ fontSize: "1.25rem", color: "#fff", lineHeight: 0 }}>
        <IconMapO />
      </Text>
      &nbsp;
      {label}
    </Button>
  );
};

export default ButtonMap;
